import { EuiButton, EuiFlexItem, EuiForm, EuiFormRow, EuiSelect, EuiSpacer, EuiText, EuiTitle } from "@elastic/eui";
import client from "api/Client";
import React, { useContext, useEffect, useState } from "react";
import { ShopContext } from "utils/Shop";
import { JsonPrice, PriceForForm } from "utils/types";

import { generateInternalProductId } from "../utils/FormUtils";
import { PriceCombiForm } from "./PriceCombiForm";

export function PriceForm({ price }: { price: PriceForForm | undefined }) {
    const [internalIdPrefix, setInternalIdPrefix] = useState("");
    const [shopGroupId, setShopGroupId] = useState("");
    const [shopGroups, setShopGroups] = useState([]);
    const [groupsLoading, setGroupsLoading] = useState(true);

    const [edibleJsonPrices, setEdibleJsonPrices] = useState<JsonPrice[]>([]);
    const [preRolledJsonPrices, setPreRolledJsonPrices] = useState<JsonPrice[]>([]);
    const [cannabisJsonPrices, setCannabisJsonPrices] = useState<JsonPrice[]>([]);

    const { shopId } = useContext(ShopContext);

    useEffect(() => {
        if (price) {
            setInternalIdPrefix(price.internal_product_id.substring(0, 3));
            setCannabisJsonPrices(price.cannabis);
            setPreRolledJsonPrices(price.pre_rolled_joints);
            setEdibleJsonPrices(price.edible);
        }

        client.get(`/v1/shop-groups?skip=0&limit=1000`).then((result) => {
            const shopGroups = result.data.filter((group) => group.shops.find((shop) => shop.id === shopId));
            const options = shopGroups.map((group) => ({
                text: group.name,
                value: group.id,
            }));
            options.unshift({ text: "", value: "-1" });
            setShopGroups(options);
            setGroupsLoading(false);

            if (price) {
                setShopGroupId(price.shop_group_id);
            }
        });
    }, [shopId, price]);

    const handleSubmit = () => {
        let payload;
        const internalProductId = generateInternalProductId(internalIdPrefix, [
            cannabisJsonPrices ?? [],
            preRolledJsonPrices ?? [],
            edibleJsonPrices ?? [],
        ]);

        payload = {
            internal_product_id: internalProductId.split(":")[0],
            shop_group_id: shopGroupId,
            half: null,
            one: null,
            two_five: null,
            five: null,
            joint: null,
            piece: null,
            cannabis: cannabisJsonPrices,
            pre_rolled_joints: preRolledJsonPrices,
            edible: edibleJsonPrices,
        };

        if (price) {
            client
                .put(`/v1/prices/${price.id}`, payload)
                .then(() => {
                    window.location.replace("/prices");
                })
                .catch((error) =>
                    alert("Prijs bestaat al. Wanneer je toch op wil slaan, kies dan een andere kassa code prefix.")
                );
        } else {
            client.post(`/v1/prices`, payload).then(() => {
                window.location.replace("/prices");
            });
        }
    };

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            console.log("Enter key pressed; submitting form");
            handleSubmit(event);
        }
    };

    return (
        <EuiForm>
            <EuiTitle>
                <EuiText>{price === undefined ? "Prijs Toevoegen" : "Prijs Bewerken"}</EuiText>
            </EuiTitle>
            <EuiSpacer />
            <EuiFormRow
                label="Shop Groep"
                labelAppend={<EuiText size="m">Selecteer een shop groep.</EuiText>}
                id="select-group"
                fullWidth
            >
                <EuiSelect
                    value={shopGroupId}
                    onChange={(e) => setShopGroupId(e.target.value)}
                    options={shopGroups}
                    isLoading={groupsLoading}
                    onKeyDown={handleKeyDown}
                    fullWidth
                />
            </EuiFormRow>
            <PriceCombiForm
                useExistingPrice={false}
                edibleJsonPrices={edibleJsonPrices}
                setEdibleJsonPrices={setEdibleJsonPrices}
                preRolledJsonPrices={preRolledJsonPrices}
                setPreRolledJsonPrices={setPreRolledJsonPrices}
                cannabisJsonPrices={cannabisJsonPrices}
                setCannabisJsonPrices={setCannabisJsonPrices}
                setInternalIdPrefix={setInternalIdPrefix}
                internalIdPrefix={internalIdPrefix}
            />
            <EuiFlexItem>
                <EuiButton
                    fill
                    onClick={() => handleSubmit()}
                    disabled={
                        shopGroupId === "-1" &&
                        internalIdPrefix.length < 1 &&
                        edibleJsonPrices.length < 1 &&
                        preRolledJsonPrices.length < 1 &&
                        cannabisJsonPrices.length < 1
                    }
                    type="submit"
                    isLoading={groupsLoading}
                >
                    {price ? "Opslaan" : "Toevoegen"}
                </EuiButton>
            </EuiFlexItem>
        </EuiForm>
    );
}
